module.exports = __webpack_public_path__ + "static/media/gb3.4d431f18.png";